import React from "react";
import FieldListFactory from "components/FieldListFactory";

const ValuesFields = ({ name }) => (
  <FieldListFactory
    name={name}
    config={[
      {
        name: "label"
      },
      {
        name: "description"
      }
    ]}
  />
);

export default ValuesFields;
